import { Injectable, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EventEmitterService {
  private sliderSubject = new Subject<any>();
    invokeSectionDetails = new EventEmitter();
    subsVar: Subscription;
    invokeEmailTemplateDetails = new EventEmitter();
    emailTemplateSub: Subscription;
    invokeNotificationDetails = new EventEmitter();
    notificationSub: Subscription;
    constructor() { 
      // This is intentional
    }

    sendClickEventForSlider(event) {
      this.sliderSubject.next(event);
  }
  get events$ () {
    return this.sliderSubject.asObservable();
  }


    getSectionDetails(defType: string, sectionName: string) {
        this.invokeSectionDetails.emit({ defType, sectionName });
    }

    getemailTemplateDetails(defType: string, sectionName: string){
        this.invokeEmailTemplateDetails.emit({ defType, sectionName });
    }

    getNotificationDetails(defType: string, sectionName: string){
        this.invokeNotificationDetails.emit({ defType, sectionName });
    }

    private messageSource = new BehaviorSubject('NOTIFICATIONCONFIG-DEF');
    currentMessage = this.messageSource.asObservable();

    changeMessage(message: string) {
      this.messageSource.next(message);
    }
}

